// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.balances-container-q01Qu {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.balances-content-THnWA {
  height: 100%;
  padding-left: 20px;
  overflow: hidden;
}

.balances-table_container-xJU4O {
  padding-right: 10px;
}

.balances-tableRow_cell-Z8Mtv:last-child {
  padding-right: 16px;
}

.balances-phone-X3MZ5 {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/balances/balances.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.content {\n  height: 100%;\n  padding-left: 20px;\n  overflow: hidden;\n}\n\n.table_container {\n  padding-right: 10px;\n}\n\n.tableRow_cell:last-child {\n  padding-right: 16px;\n}\n\n.phone {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `balances-container-q01Qu`,
	"content": `balances-content-THnWA`,
	"table_container": `balances-table_container-xJU4O`,
	"tableRow_cell": `balances-tableRow_cell-Z8Mtv`,
	"phone": `balances-phone-X3MZ5`
};
export default ___CSS_LOADER_EXPORT___;
